var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4035",
    "data-name": "Path 4035",
    d: "M382.808,222.947a10,10,0,1,1,10-10A10.011,10.011,0,0,1,382.808,222.947Zm0-18.926a8.926,8.926,0,1,0,8.926,8.926A8.936,8.936,0,0,0,382.808,204.021Z",
    transform: "translate(-372.808 -202.947)",
    fill: "#006341"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016",
    transform: "translate(7.393 4.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4036",
    "data-name": "Path 4036",
    d: "M393.616,219.512v5.4a.141.141,0,0,0,.141.141h2.006a.141.141,0,0,0,.141-.141v-5.491h1.455a.141.141,0,0,0,.14-.129l.14-1.654a.141.141,0,0,0-.14-.153H395.9v-1.174a.5.5,0,0,1,.5-.5h1.121a.141.141,0,0,0,.141-.141v-1.654a.141.141,0,0,0-.141-.141h-1.894a2.012,2.012,0,0,0-2.013,2.013v1.595h-1a.141.141,0,0,0-.141.141v1.654a.141.141,0,0,0,.141.141h1Z",
    transform: "translate(-392.472 -213.881)",
    fill: "#006341",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFooter);
export default __webpack_public_path__ + "static/media/facebook-footer.7db150fb381460450c5322f8e65a7717.svg";
export { ForwardRef as ReactComponent };